module.exports = __webpack_public_path__ + "img/palani-brown.16de62b.webp";